import { css } from 'styled-components';
import { MODAL_SIZE } from './types';
import { ModalTags } from './class-name-tags';
import { spacing } from '../../atoms/spacing/spacing';
import { addAlpha } from '../../atoms/colors/utils';
import { colors } from '../../atoms/colors/colors';
export const commonTheme = {
    overlay: css `
    &.${ModalTags.overlay} {
      background-color: ${addAlpha(colors.black, 0.5)};
      position: fixed;
      inset: 0;
    }
  `,
    base: css `
    &.${ModalTags.content} {
      box-sizing: border-box;
      border-radius: 6px;

      display: flex;
      flex-direction: column;

      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      height: auto;

      max-height: 85vh;
      max-width: 85vw;
      padding: ${spacing.spacing32};
    }
  `,
    tiny: css `
    width: ${MODAL_SIZE.tiny};
    min-height: 190px;
  `,
    small: css `
    width: ${MODAL_SIZE.small};
    min-height: 425px;
  `,
    medium: css `
    width: ${MODAL_SIZE.medium};
    min-height: 525px;
  `,
    large: css `
    width: ${MODAL_SIZE.large};
    min-height: 655px;
  `,
};
//# sourceMappingURL=common-theme.js.map